// src/payment/routePaths.js
// Routes dédiées au module Payment (abonnements Flouci)

export const PAYMENT_ROUTES = {
  PLANS: "/payment",
  SUCCESS: "/payment/success",
  FAIL: "/payment/fail",
};

export default PAYMENT_ROUTES;
